<template>
  <div>
    <wty-UserGroup :who="'service'"></wty-UserGroup>
  </div>
</template>
<script>
import wtyUserGroup from '@/components/wty-userGroup.vue';
export default {
  name:"userGroup",
  data(){
    return{

    }
  },
  components:{wtyUserGroup}
}
</script>

<style lang="less" scoped>

</style>